import { render, staticRenderFns } from "./CounterField.vue?vue&type=template&id=480241f4&scoped=true&"
import script from "./CounterField.vue?vue&type=script&lang=js&"
export * from "./CounterField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480241f4",
  null
  
)

export default component.exports